<template>
  <div>
    <h1 class="modal-h1 mb-3">
      <button type="button"
              class="btn btn-back"
              @click="$emit('cancel')"
      />
      Create Carrier
    </h1>
    <div class="l-bg-white">
      <form @submit.prevent="submit"
            autocomplete="no"
      >
        <div class="row mb-3">
          <div class="col-12">
            <div class="select-wrap">
              <label>Carrier name</label>
              <input v-model="carrier.name"
                     type="text"
                     placeholder="Enter Name"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col text-right">
            <button type="button"
                    class="btn btn-secondary"
                    @click="$emit('cancel')"
            >
              Cancel
            </button>
            <button class="btn btn-primary ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled || !formInvalid"
            >
              Create
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import ErrorField from '../ErrorField';
import Errors from '../../classes/Errors';

export default {
  components: {
    ErrorField,
  },
  data: () => ({
    carrier: {
      name: '',
    },
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  computed: {
    formInvalid() {
      return !!this.carrier.name.length;
    },
  },
  methods: {
    submit() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .post('carriers', { ...this.carrier })
        .then(() => {
          toastr.success('Successfully created carrier');
          this.$emit('update');
          this.$emit('cancel');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.buttonDisabled = false;
          this.loadingButton = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdown-menu {
  max-height: 500px;
  overflow-y: auto;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/carriers/CarriersCreate.vue